import { authenticationActions } from "./slices";

const {
  setUserDetails,
  setAccessToken,
  setSignUpDetails,
  setResetAuthentication,
} = authenticationActions;

const callSetUserDetails = (values) => (dispatch) => {
  dispatch(setUserDetails(values));
};

const callSetSignUpDetails = (values) => (dispatch) => {
  dispatch(setSignUpDetails(values));
};

const callSetAccessToken = (value) => (dispatch) => {
  dispatch(setAccessToken(value));
};

const callSetResetAuthentication = () => (dispatch) => {
  dispatch(setResetAuthentication());
};

const actions = {
  callSetAccessToken,
  callSetUserDetails,
  callSetSignUpDetails,
  callSetResetAuthentication,
};

export default actions;
